import { useAtomValue } from 'jotai'
import { UserService } from '@duck/api-definitions'
import { pythonNotebookV2EnabledAtom } from '@/store/debugAtoms'
import { useUserBadges } from './useUserBadges'

/**
 * Whether the rebuilt Python notebook (PythonNotebookV2) should replace the
 * JupyterLite one. Enabled for users carrying the XplPython2 badge (admin-assigned),
 * or on any browser where the Konami debug switch is on (developer override).
 */
export const usePythonNotebookV2 = (): boolean => {
  const debugEnabled = useAtomValue(pythonNotebookV2EnabledAtom)
  const { hasBadge } = useUserBadges()
  return debugEnabled || hasBadge(UserService.UserBadge.XplPython2)
}
